import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { useStyles } from "./styles";
import { connect } from "react-redux";
import { PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../../utilities/constants";
import { Box } from "@material-ui/core";
import { getAppointmentInsightRequest } from "../../AppointmentApiActions";
import { getUserInfo } from "../../../../utilities/storage";

const AppointmentInsight = ({ getAppointmentInsight, appointments }) => {
  const classes = useStyles();
  const orgId = getUserInfo()?.Admin?.Organization[0]?.id;
  const [paginationParams, setPaginationParams] = useState({
    page: 0,
    rowsPerPage: PAGE_SIZE,
    searchData: {},
  });
  useEffect(() => {
    getAppointmentInsight(orgId).then((res) => {});
  }, [getAppointmentInsight]);

  const tableData = (appointments?.data || []).map((item) => ({
    ...item,
    fullName: `${item.userName || ""} ${item.lastName || ""}`.trim(),
  }));

  const columns = [
    {
      field: "fullName",
      title: "Doctor Name",
      filtering: true,
      defaultFilter: paginationParams.searchData["fullName"],
      cellStyle: {
        width: "25%",
      },
      headerStyle: {
        width: "25%",
      },
    },
    {
      field: "email",
      title: "Doctor Email",
      filtering: true,
      defaultFilter: paginationParams.searchData["email"],
      cellStyle: {
        width: "25%",
      },
      headerStyle: {
        width: "25%",
      },
    },
    {
      field: "lastAppointment",
      title: `Today's Appointments`,
      filtering: true,
      defaultFilter: paginationParams.searchData["lastAppointment"],
      cellStyle: {
        width: "20%",
      },
      headerStyle: {
        width: "20%",
      },
    },
    {
      field: "last7DaysAppointments",
      title: `Last 7 days Appointments`,
      filtering: true,
      defaultFilter: paginationParams.searchData["last7DaysAppointments"],
      cellStyle: {
        width: "20%",
      },
      headerStyle: {
        width: "20%",
      },
    },
    {
      field: "last30DaysAppointments",
      title: `Last 30 days Appointments`,
      filtering: true,
      defaultFilter: paginationParams.searchData["last30DaysAppointments"],
      cellStyle: {
        width: "20%",
      },
      headerStyle: {
        width: "20%",
      },
    },
    {
      field: "allTimeAppointment",
      title: `All time Appointments`,
      filtering: true,
      defaultFilter: paginationParams.searchData["allTimeAppointment"],
      cellStyle: {
        width: "20%",
      },
      headerStyle: {
        width: "20%",
      },
    },
  ];

  return (
    <Box className={classes.outerContainer}>
      <Box mt={1}>
        <MaterialTable
          title="Appointment Insight"
          columns={columns}
          data={tableData}
          options={{
            search: false,
            filtering: true,
            sorting: false,
            horizontalScroll: true,
            draggable: false,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            pageSize: paginationParams.rowsPerPage,
            emptyRowsWhenPaging: false,
          }}
          // pages={Math.ceil(appointments?.count / paginationParams?.rowsPerPage)}
          totalCount={appointments?.count}
          page={paginationParams.page}
          onChangeRowsPerPage={(pageSize) => {
            let data = Object.assign({}, paginationParams);
            data["rowsPerPage"] = pageSize;
            setPaginationParams(data);
          }}
          onChangePage={(page) => {
            let data = Object.assign({}, paginationParams);
            data["page"] = page;
            setPaginationParams(data);
          }}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    appointments: state.appointments.appointments,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAppointmentInsight: (orgId) => {
      return dispatch(getAppointmentInsightRequest(orgId)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentInsight);
